module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAAe0lEQVR42u3aQQ0AIQwAwVrgcxLQhSh0XYIfkmKiv85jDcx7IzOjcwEAAAAAAAAAAAAAQHOAf8ys7J6vtNirNAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAKATgFMUAAAAAAAAAAAAAIBWPU8uNKhpVndvAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/Guinea.png
// module id = 5T+X
// module chunks = 0 62 63